var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotypeMolecule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3149,
    cy: 25.9624,
    r: 25.0376,
    fill: "url(#paint0_radial_3004_1558)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9449 29.0407L31.1496 27.1964C31.476 25.6543 31.1684 23.9832 30.1748 22.6148L35.1857 17.604C37.7171 19.1443 40.9994 17.317 40.9994 14.3302C41 12.2177 39.2823 10.5 37.1704 10.5C34.1806 10.5 32.3575 13.7847 33.8966 16.3137L28.8858 21.3246C26.7346 19.7625 23.7847 19.869 21.7485 21.6134L19.1983 19.4458C20.4704 16.9137 18.6207 13.9033 15.775 13.9033C13.6637 13.9033 11.9454 15.6211 11.9454 17.7329C11.9454 20.8668 15.511 22.6505 18.0164 20.8347L20.566 23.0023C19.3599 24.9804 19.4556 27.4991 20.8252 29.3852L17.4896 32.7207C14.3352 30.5822 10 32.837 10 36.698C10 39.3457 12.1543 41.5 14.802 41.5C18.66 41.5 20.9202 37.1679 18.7793 34.0104L22.1148 30.6748C23.5129 31.6896 25.2578 32.0075 26.8829 31.6066L28.956 36.5067C26.9943 38.2468 28.2282 41.5 30.8493 41.5C32.4247 41.5 33.7059 40.2182 33.7059 38.6434C33.7059 37.0062 32.3146 35.6699 30.6344 35.7953L28.5613 30.8946C29.3556 30.3957 30.021 29.7097 30.4939 28.8978L35.2898 30.7426C35.2214 32.3762 36.5316 33.7203 38.1434 33.7203C39.7188 33.7203 41 32.4386 41 30.8637C41 28.213 37.6578 26.9778 35.9449 29.0407Z",
    fill: "#0C0D15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3004_1558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3149 25.9624) rotate(90) scale(25.0376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#9BF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18F1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeMolecule);
export default __webpack_public_path__ + "static/media/logotype-molecule.aecbdf55d181e559abbbba1dfc80121b.svg";
export { ForwardRef as ReactComponent };